module.exports = __webpack_public_path__ + "media/images/fail-icon-a70d97fd.png";